module.exports = __webpack_public_path__ + "static/media/confirmation-tick.6bdd77f4.svg";